import { Highlight } from './highlight.style';
import { callToActionProps } from '@exploration/shared-types';
import { useTheme } from 'styled-components';

export interface HighlightProps {
  headline: string;
  subHeadline: string;
  callToAction: Array<callToActionProps>;
  backgroundColor?: string;
  image: {
    alt: string;
    source: {
      publicUrl: string;
    };
  };
  banner?: boolean;
  reverseDesktop?: boolean;
  reverseMobile?: boolean;
  className?: string;
  id?: string;
}

export const HighlightSection = ({
  headline,
  subHeadline,
  callToAction,
  image,
  reverseMobile,
  reverseDesktop,
  backgroundColor,
  className,
  id,
}: HighlightProps) => {
  const { midwestColors: colors } = useTheme();
  return (
    <Highlight
      id={id}
      reverseDesktop={reverseDesktop}
      reverseMobile={reverseMobile}
      className={className}
      backgroundColor={backgroundColor || colors.backgroundSecondary}
      callToAction={{
        title: { children: headline },
        description: { children: subHeadline },
        ...(callToAction?.[0] ?? {}),
      }}
      image={{
        src: image?.source?.publicUrl,
        alt: image?.alt,
        height: 100,
        width: 1080,
        objectFit: 'contain',
      }}
    />
  );
};
